import React from 'react';
import styles from "../styles/standings-widget.module.scss";
import {OutrightsWidgetAsync} from "../../outrights-widget/components/outrights-widget.async";
import classNames from "classnames";
import {observer} from "mobx-react";

export const StandingsWidgetOutrights = observer(({controller, isCollapsed, isPreviewStandings}) => {
  const {state} = controller;
  const {selectedCompetitionId, isWidget} = state;

  const shouldRenderOutrights: Boolean = selectedCompetitionId > 0 && !isPreviewStandings && !isCollapsed && !isWidget;

  return (
    shouldRenderOutrights ? <div className={classNames(styles.outrights)}>
      <OutrightsWidgetAsync competitionsId={[selectedCompetitionId]}/>
    </div> : null
  )
});
